module.exports = __webpack_public_path__ + "media/logos/forbes-logo-white-b31f2bf3.png";